<section class="desk-container">
	@if (openRecords().length > 0) {
		<section class="tab-content-container">
			<lvr-tabs class="tab-content-container">
				@for (record of openRecords(); track record.id) {
					<lvr-tab
						[icon]="record.icon"
						[route]="[record.route]"
						[isActive]="isActive(record.route)"
						(destroy)="closeRecord(record.id)"
						>{{ record.title }}</lvr-tab
					>
				}
			</lvr-tabs>

			<section class="tab-content border-top" #tabContent>
				<router-outlet></router-outlet>
			</section>
		</section>
		@if (showClientSideTabs() && (!isRestricted() || hasAdditionalAssignmentAccess())) {
			<lvr-tabs class="vertical vertical-tab-group">
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(overviewRoute(), { exact: true })"
					icon="person"
					[route]="[overviewRoute()]"
					>{{ 'client.menu.overview' | transloco }}</lvr-tab
				>
				@if (canReadAssignments()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="assignment"
						[isActive]="isActive(assignmentRoute(), { exclude: moveSuffixes })"
						[route]="[assignmentRoute()]"
						>{{ 'client.menu.assignments' | transloco }}</lvr-tab
					>
				}
				@if (showPhaseSwitcher() && !isRepresentativeMode()) {
					<lvr-tab
						[temporary]="true"
						[showDestroyButton]="false"
						icon="airline_stops"
						[isActive]="isActive(assignmentTransitionRoute())"
						[route]="[assignmentTransitionRoute()]"
						>{{ phaseSwitcherLabel() | transloco }}</lvr-tab
					>
				}
				@if (canReadDisabilityReports()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="accessibility_new"
						[isActive]="isActive(disabilitiesRoute())"
						[route]="[disabilitiesRoute()]"
						>{{ 'client.menu.disabilities' | transloco }}</lvr-tab
					>
				}
				@if (canReadCareers()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="business_center"
						[isActive]="isActive(careerRoute())"
						[route]="[careerRoute()]"
						>{{ 'client.menu.career' | transloco }}</lvr-tab
					>
				}
				@if (canReadClientEnvironments()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="diversity_3"
						[isActive]="isActive(relativesRoute())"
						[route]="[relativesRoute()]"
						>{{ 'client.menu.relatives' | transloco }}</lvr-tab
					>
				}
				@if (canReadDocuments()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="folder"
						[isActive]="isActive(documentsRoute())"
						[route]="[documentsRoute()]"
						>{{ 'client.menu.documents' | transloco }}</lvr-tab
					>
				}
			</lvr-tabs>
		}
		@if (showInstitutionSideTabs()) {
			<lvr-tabs class="vertical vertical-tab-group">
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(overviewRoute(), { exact: true })"
					icon="business"
					[route]="[overviewRoute()]"
					>{{ 'institution.menu.overview' | transloco }}</lvr-tab
				>
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(workplaceRoute())"
					icon="business_center"
					[route]="[workplaceRoute()]"
					>{{ 'institution.menu.workplace' | transloco }}</lvr-tab
				>
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(contactPersonRoute())"
					icon="book"
					[route]="[contactPersonRoute()]"
					>{{ 'institution.menu.contact_person' | transloco }}</lvr-tab
				>
			</lvr-tabs>
		}
		@if (showSponsorSideTabs()) {
			<lvr-tabs class="vertical vertical-tab-group">
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(overviewRoute(), { exact: true })"
					icon="account_balance"
					[route]="[overviewRoute()]"
					>{{ 'sponsor.menu.overview' | transloco }}</lvr-tab
				>
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(contactPersonRoute())"
					icon="book"
					[route]="[contactPersonRoute()]"
					>{{ 'sponsor.menu.contact_person' | transloco }}</lvr-tab
				>
			</lvr-tabs>
		}
		@if (showUserSideTabs()) {
			<lvr-tabs class="vertical vertical-tab-group">
				<lvr-tab
					[showDestroyButton]="false"
					icon="person"
					[isActive]="isActive(overviewRoute(), { exact: true })"
					[route]="[overviewRoute()]"
					>{{ 'user.user_view.overview' | transloco }}</lvr-tab
				>
				@if (canReceiveRepresentation()) {
					<lvr-tab
						[showDestroyButton]="false"
						icon="groups"
						[isActive]="isActive(userRepresentationRoute())"
						[route]="[userRepresentationRoute()]"
						>{{ 'specialist.representation.new_representations_title' | transloco }}</lvr-tab
					>
				}
				@if (showUserAssignmentMoveTab()) {
					<lvr-tab
						[temporary]="true"
						[showDestroyButton]="false"
						icon="arrow_forward"
						[isActive]="isActive(userAssignmentTransitionRoute())"
						[route]="[userAssignmentTransitionRoute()]"
						>{{ 'base.button.move' | transloco }}</lvr-tab
					>
				}
			</lvr-tabs>
		}
		@if (showIsoSideTabs()) {
			<lvr-tabs class="vertical vertical-tab-group">
				<lvr-tab
					[showDestroyButton]="false"
					[isActive]="isActive(overviewRoute(), { exact: true })"
					icon="apartment"
					[route]="[overviewRoute()]"
					>{{ 'sponsor.menu.overview' | transloco }}</lvr-tab
				>
			</lvr-tabs>
		}
	} @else {
		<lvr-empty-desk></lvr-empty-desk>
	}
</section>
